module.exports = __webpack_public_path__ + "img/Takskift.80cc0486.jpg";